import { InMemoryCache } from 'apollo-cache-inmemory'
import { withClientState } from 'apollo-link-state'

import { defaults, resolvers } from './resolvers/signaturePoints'

const stateLink = withClientState({
  cache: new InMemoryCache(),
  defaults,
  resolvers,
})

export default stateLink
